import type { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#core/components/auth/layout/auth.component').then((m) => m.AuthComponent),
        children: [
            {
                path: 'login',
                loadComponent: () => import('#core/components/auth/login/login.component').then((m) => m.LoginComponent),
            },
            {
                path: 'password/forgot',
                loadComponent: () =>
                    import('#core/components/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
            },
            {
                path: 'password/confirm',
                loadComponent: () =>
                    import('#core/components/auth/forgot-password-confirm/forgot-password-confirm.component').then(
                        (m) => m.ForgotPasswordConfirmComponent
                    ),
            },
            {
                path: 'password/new/:user_id/:token',
                loadComponent: () =>
                    import('#core/components/auth/new-password/new-password.component').then((m) => m.NewPasswordComponent),
            },
            {
                path: 'needs-confirm',
                loadComponent: () =>
                    import('#core/components/auth/needs-confirm/needs-confirm.component').then((m) => m.NeedsConfirmComponent),
            },
            {
                path: 'confirm/:uid/:token',
                loadComponent: () => import('#core/components/auth/confirm/confirm.component').then((m) => m.ConfirmComponent),
            },
            {
                path: ':user_id/edit-misc',
                loadChildren: () => import('#modules/user/routes/logged-out-user.routes').then((m) => m.LOGGED_OUT_USERS_ROUTES),
            },
        ],
    },
];
